import 'prosemirror-state';
import 'prosemirror-model';

/**
 * 统一样式前缀
 */ var CLASSNAME_PREFIX = "ct";

var classNamePrefix = function(className) {
    var prefix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : CLASSNAME_PREFIX;
    return "".concat(prefix, "-").concat(className);
};

var isOnLoad = false;
var loadedCallback = [];
var loadSource = function() {
    var scriptNode = document.createElement("script");
    scriptNode.src = "https://s3plus-noq.meituan.net/v1/mss_9d9e5b6deadb43adac208535b2d92427/files/katex.min.js";
    scriptNode.onload = function() {
        return loadedCallback.forEach(function(fn) {
            return fn();
        });
    };
    document.body.appendChild(scriptNode);
    var linkTag = '\n      <link rel="stylesheet" href="https://s3plus-noq.meituan.net/v1/mss_9d9e5b6deadb43adac208535b2d92427/files/katex.min.css" />\n      ';
    var div = document.createElement("div");
    div.innerHTML = linkTag;
    Array.from(div.children).forEach(function(node) {
        document.body.appendChild(node);
    });
};
function renderLatex(content, newNode) {
    if (!window.katex) {
        var cb = function() {
            window.katex.render(content, newNode, {
                displayMode: true,
                throwOnError: false,
                errorColor: "#cc0000",
                strict: "warn",
                macros: {
                    "\\f": "f(#1)"
                }
            });
        };
        loadedCallback.push(cb);
        if (!isOnLoad) {
            isOnLoad = true;
            loadSource();
        }
    } else {
        window.katex.render(content, newNode, {
            displayMode: true,
            throwOnError: false,
            errorColor: "#cc0000",
            strict: "warn",
            macros: {
                "\\f": "f(#1)"
            }
        });
    }
}

function styleInject(css, ref) {
    if (ref === void 0) ref = {};
    var insertAt = ref.insertAt;
    if (!css || typeof document === "undefined") {
        return;
    }
    var head = document.head || document.getElementsByTagName("head")[0];
    var style = document.createElement("style");
    style.type = "text/css";
    if (insertAt === "top") {
        if (head.firstChild) {
            head.insertBefore(style, head.firstChild);
        } else {
            head.appendChild(style);
        }
    } else {
        head.appendChild(style);
    }
    if (style.styleSheet) {
        style.styleSheet.cssText = css;
    } else {
        style.appendChild(document.createTextNode(css));
    }
}

var css_248z = ".ct-latex{font-size:14px;border:1px solid #fff}.ct-latex .katex .katex-mathm{display:none}span.ct-latex{line-height:40px;min-height:40px;margin:0;padding:0}span.ct-latex,span.ct-latex code{display:inline-block}.ct-latex code{display:block;margin:0;padding:8px 16px;font-size:13px;white-space:pre;color:#333;font-family:Lucida Console,Consolas,Monaco,Andale Mono,Ubuntu Mono,monospace;word-wrap:break-word;border:0}.ct-latex:hover{border-radius:2px;border:1px solid #ddd}.ProseMirror .ProseMirror-selectednode .ct-latex{border:1px solid #0082a6}";
styleInject(css_248z);

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function getContent(node) {
    var content = "";
    if (node.dataset.content !== undefined) {
        content = node.dataset.content;
    } else {
        var $code = node.querySelector("code");
        if ($code) {
            content = $code.textContent;
        }
    }
    return content;
}
var latexRender = function latexRender() {
    var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    _classCallCheck(this, latexRender);
    this.fragmentRender = function(node) {
        var content = getContent(node);
        node.innerHTML = "";
        renderLatex(content, node);
    };
    this.fragmentCls = ".".concat(classNamePrefix("latex"));
    this.config = config;
};

export default latexRender;
export { getContent };
//# sourceMappingURL=render.js.map
